import http from './';
import AsyncStorage from "@react-native-async-storage/async-storage";

export const fetchKholasehVaziat = async (fltr) => {
    try {
        const token = await AsyncStorage.getItem("token");

        var datas = JSON.stringify({ 'hesab': fltr.hesab, 'sal': fltr.sal, 'mah':fltr.mah });
        const headers = {
            'x-auth':JSON.parse(token),
            'Content-Type': 'application/json',
          } 

        const {
            data,
        } = await http.post(`${http.url2}/kholasehVaziat`,datas,{
            headers: headers
          });

        return data.Data;
    } catch (err) {
        console.log(err);
    }
};
